import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-environment',
  templateUrl: './environment.component.html',
  styleUrls: ['./environment.component.css']
})
export class EnvironmentComponent extends BaseComponent implements OnInit {

  env: any = {};
  dbenv: any = {};
  constructor(public injector: Injector) { super(injector) }

  async ngOnInit() {
    this.env = environment;
    this.dbenv = await this.db.get("Authenticate", "GetEnvironment")


  }


}
